import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DeleteSharp, Delete } from "@mui/icons-material";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Tooltip,
  Box,
  IconButton,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Switch,
  FormControl,
  CircularProgress
} from "@mui/material";
// components
import Page from "../components/Page";
import { deletePoll, getPollPrimeResult, insertPrimePoll } from "src/api/commonapi";
// StateData
import { fetchPrimeAllPollList } from "src/utils/common";
import { notification } from "src/utils/messages";
import Modal from "@mui/material/Modal";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import CustomLoader from "src/components/CustomLoader";
// ----------------------------------------------------------------------

export default function Poll() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const [getdata, setgetdata] = useState({
    p_type: 4,
    p_type_id: "",
    s_date: null,
    e_date: null,
    show_on_home: 0
  });
  const [myModal, setMyModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [answer, setanswer] = useState([]);
  const [response, setresponse] = useState(0);
  const [polldata, setpolldata] = useState([]);
  const [pollResult, setPollResult] = useState({});
  const [answerUser, setAnswerUser] = useState(0);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  // Modal Style
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };
  useEffect(async () => {
    setLoading(true);
    setpolldata(await fetchPrimeAllPollList(loginUser.u_type));
    setLoading(false);
  }, [response]);

  // Delete Poll
  const deletepoll = async (p_id) => {
    const resp = await deletePoll(p_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  // Get Poll Result
  const getPollResult = async (p_id) => {
    const resp = await getPollPrimeResult(p_id);
    if (resp.status != 0) {
      setPollResult(resp);
    } else {
    }
  };

  // Cancel Modal
  const cancelModal = () => {
    setMyModal(false);
  };

  const modifiedData = polldata.map((item, index) => ({
    no: index + 1,
    p_question: item.p_question,
    s_date: item.s_date,
    e_date: item.e_date
  }));

  const expo_columns = [
    { label: "No", key: "no" },
    { label: "Poll Question", key: "p_question" },
    { label: "Start Date", key: "s_date" },
    { label: "End Date", key: "e_date" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      sortable: true
    },
    {
      name: "Start Date",
      selector: (row) => row.s_date,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.e_date,
      sortable: true
    },
    {
      name: "Poll Question",
      selector: (row) => row.p_question
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <a
            onClick={() => {
              setDvisible({ mval: true, id: row.p_id });
            }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </a>
          <a
            onClick={() => {
              getPollResult(row.p_id);
              setMyModal(true);
            }}
          >
            <Tooltip title="View Result">
              <IconButton>
                <PlaylistAddCheckIcon color="success" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ];

  const onChangeFunction = (e) => {
    setgetdata({
      ...getdata,
      [e.target.name]: e.target.value
    });
  };

  const addanswer = () => {
    setanswer([
      ...answer,
      {
        value: ""
      }
    ]);
  };
  const handleSubmit = async () => {
    let fdata = new FormData();
    fdata.append("p_type", getdata.p_type);
    fdata.append("p_type_id", getdata.p_type_id);
    fdata.append("s_date", getdata.s_date);
    fdata.append("e_date", getdata.e_date);
    fdata.append("p_question", getdata.question);
    fdata.append("show_on_home", getdata.show_on_home);
    Object.keys(answer).map((key) => {
      fdata.append("p_answer", answer[key].value);
    });
    if (
      getdata.question == "" ||
      getdata.question == undefined ||
      !getdata.s_date ||
      !getdata.e_date
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
    } else {
      if (answer.length == 0 || (answer.length > 0 && answer.some((e) => e.value == ""))) {
        let notify = notification({
          type: "error",
          message: "Please Enter Answers"
        });
        notify();
      } else {
        setLoading(true);
        const resp = await insertPrimePoll(fdata);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setgetdata({
            p_type: 4,
            p_type_id: "",
            s_date: null,
            e_date: null,
            show_on_home: 0
          });
          setanswer([]);
        }
        setLoading(false);
      }
    }
  };

  const handleValueChange = (index, newValue) => {
    const updatedAnswer = [...answer];
    updatedAnswer[index].value = newValue;
    setanswer(updatedAnswer);
  };

  const deleteObject = (index) => {
    const newArray = answer.filter((_, i) => index != i);
    setanswer(newArray);
  };

  const export_readPollDetailColumns = [
    { label: "Person Name", key: "m_name" },
    { label: "Chapter Name", key: "chpt_name" }
  ];
  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deletepoll} />
      <Modal
        open={myModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Poll Result
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "280px", overflowY: "scroll" }}>
              <div className="Poll_details">
                <div
                  className="question"
                  style={{
                    padding: "5px 0",
                    justifyContent: "start",
                    alignItems: "center"
                  }}
                >
                  <b> Poll Question &nbsp;</b> : {pollResult.question}
                </div>
                <div
                  className="ans_counter"
                  style={{
                    padding: "5px 0",
                    justifyContent: "start",
                    alignItems: "center"
                  }}
                >
                  <b> Total Answer &nbsp;</b> : {pollResult.total_vote}
                </div>
              </div>

              <div className="poll_question">
                <b> Poll Answers &nbsp;</b> <br />
                {pollResult.option?.map((e) => {
                  var pre =
                    Math.round(
                      ((e.vote_counter * 100) / pollResult.total_vote + Number.EPSILON) * 100
                    ) / 100;

                  return (
                    <>
                      <div
                        className="answerList"
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          paddingBottom: "10px",
                          marginBottom: "10px"
                        }}
                        onClick={() => {
                          setAnswerUser(e.p_c_id);
                        }}
                      >
                        <div className="answer" style={{ marginRight: "20px" }}>
                          {e.p_c_option}
                        </div>
                        <div
                          style={{
                            width: "50%",
                            border: "1px solid #00ab55",
                            borderRadius: "20px"
                          }}
                        >
                          <div
                            style={{
                              width: pre + "%",
                              backgroundColor: "#00ab55",
                              color: "#fff",
                              padding: "0 10px ",
                              borderRadius: "20px"
                            }}
                          >
                            {e.vote_counter}
                          </div>
                        </div>
                        <div style={{ marginLeft: "20px" }}>
                          <p style={{ fontSize: "13px" }}>{pre + "%"}</p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "start",
                          marginBottom: "20px"
                        }}
                      >
                        <div
                          className="answerUser"
                          style={
                            answerUser != 0 && answerUser == e.p_c_id
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <table
                            style={{
                              border: "1px solid #000",
                              borderCollapse: "collapse"
                            }}
                          >
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #000",
                                  borderCollapse: "collapse",
                                  padding: "5px"
                                }}
                              >
                                Persone Name
                              </td>
                              <td
                                style={{
                                  border: "1px solid #000",
                                  borderCollapse: "collapse",
                                  padding: "5px"
                                }}
                              >
                                Chapter Name
                              </td>
                            </tr>
                            {pollResult.userlist?.map((us) => {
                              if (us.p_c_id == e.p_c_id) {
                                return (
                                  <>
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          borderCollapse: "collapse",
                                          padding: "5px"
                                        }}
                                      >
                                        {us.m_name}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          borderCollapse: "collapse",
                                          padding: "5px"
                                        }}
                                      >
                                        {us.chpt_name}
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            })}
                          </table>
                        </div>
                        {answerUser != 0 &&
                          answerUser == e.p_c_id &&
                          pollResult.userlist?.filter((us) => us.p_c_id == e.p_c_id).length > 0 && (
                            <Button className="btn btn-export" style={{ marginLeft: "10px" }}>
                              <CSVLink
                                data={pollResult.userlist?.filter((us) => us.p_c_id == e.p_c_id)}
                                headers={export_readPollDetailColumns}
                                filename={`Poll Result.csv`}
                                className="btn btn-primary test"
                                target="_blank"
                              >
                                Export CSV
                              </CSVLink>
                            </Button>
                          )}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button variant="outlined" onClick={cancelModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Page title="Poll | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Poll
            </Typography>
          </Stack>
          <Card style={{ padding: "25px", marginBottom: "25px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack>
                  <FormControl component="fieldset">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            name="show_on_home"
                            checked={getdata.show_on_home == 0 ? false : true}
                            onChange={(e) => {
                              let x = 0;
                              if (e.target.checked == true) x = 1;

                              setgetdata({
                                ...getdata,
                                [e.target.name]: x
                              });
                            }}
                            value="0"
                          />
                        }
                        label="Show On Home Screen"
                      />
                    </FormGroup>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={enGB}
                    style={{ marginTop: "15px" }}
                  >
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={
                        getdata.s_date != null
                          ? new Date(getdata.s_date.split("-").reverse().join("-"))
                          : null
                      }
                      minDate={new Date()}
                      onChange={(newDate) => {
                        if (newDate instanceof Date && !isNaN(newDate)) {
                          const day = String(newDate.getDate()).padStart(2, "0");
                          const month = String(newDate.getMonth() + 1).padStart(2, "0");
                          const year = newDate.getFullYear();

                          const formattedNewStart = `${day}-${month}-${year}`;

                          let updatedForm = {
                            ...getdata,
                            s_date: formattedNewStart
                          };

                          // Check end date
                          if (
                            getdata.e_date &&
                            new Date(getdata.e_date.split("-").reverse().join("-")) <
                              new Date(formattedNewStart.split("-").reverse().join("-"))
                          ) {
                            updatedForm.e_date = "";

                            const notify = notification({
                              type: "error",
                              message: "End date cannot be less than start date."
                            });
                            notify();
                          }

                          setgetdata(updatedForm);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} disabled onKeyDown={(e) => e.preventDefault()} />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={enGB}
                    style={{ marginTop: "15px" }}
                  >
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={
                        getdata.e_date != null
                          ? new Date(getdata.e_date.split("-").reverse().join("-"))
                          : null
                      }
                      minDate={
                        getdata.s_date
                          ? new Date(getdata.s_date.split("-").reverse().join("-"))
                          : new Date()
                      }
                      onChange={(newDate) => {
                        if (newDate instanceof Date && !isNaN(newDate)) {
                          const day = String(newDate.getDate()).padStart(2, "0");
                          const month = String(newDate.getMonth() + 1).padStart(2, "0");
                          const year = newDate.getFullYear();

                          setgetdata({
                            ...getdata,
                            e_date: `${day}-${month}-${year}`
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    required={true}
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Question"
                    name="question"
                    id="outlined-required"
                    onChange={onChangeFunction}
                    value={getdata?.question ? getdata?.question : ""}
                    error={getdata.question == "" ? true : false}
                    helperText={getdata.question == "" ? "Please Enter Poll Question" : ""}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                {answer &&
                  answer?.map((ans, i) => {
                    return (
                      <>
                        <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <Grid container spacing={2}>
                            <Grid item xs={11} style={{ paddingLeft: "0px" }}>
                              <TextField
                                style={{ marginTop: "0px" }}
                                fullWidth
                                autoComplete="off"
                                type="text"
                                label="Answer"
                                // name="answer"
                                id="outlined-required"
                                onChange={(e) => handleValueChange(i, e.target.value)}
                                value={ans.value}
                                error={ans?.value == null ? true : false}
                                helperText={ans.value == null ? "Please Enter Poll Answer" : ""}
                              />
                            </Grid>
                            <Grid item xs={1} className="d-flex align-item-center">
                              <IconButton
                                color="error"
                                aria-label="delete"
                                onClick={() => deleteObject(i)}
                              >
                                <Delete />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Stack>
                      </>
                    );
                  })}
                <Button onClick={addanswer} style={{ marginTop: "15px" }} variant="contained">
                  Add Answer
                </Button>
              </Grid>
            </Grid>
            <Button
              onClick={handleSubmit}
              style={{ marginTop: "15px" }}
              variant="contained"
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              Add Poll
            </Button>
          </Card>
          <Card>
            {polldata && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={modifiedData}
                    headers={expo_columns}
                    filename={"PollData.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  highlightOnHover
                  pagination
                  columns={columns}
                  data={polldata != null && polldata}
                  progressPending={loading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
}
